<template>
  <div>
    <sea-page
      title="Cronologia stato fascicolo"
      header="Cronologia stato fascicolo"
      showCompanyHeader
      back
    >
      <sea-page-content
        :fetchList="fetchList"
        toolbar
        pulsanteAggiorna
        hideRapidSearch
      >
        <template v-slot:table="{ attrs, height }">
          <v-data-table
            v-bind="attrs"
            :height="height"
            :headers="headers"
            :items="items"
            dense
            disable-sort
          >
          </v-data-table>
        </template>
      </sea-page-content>
    </sea-page>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const headers = [
  { text: "Data", value: "data" },
  { text: "Ora", value: "ora" },
  { text: "Utente", value: "utente" },
  { text: "Cognome e nome", value: "cognomeNome" },
  { text: "Tipo", value: "tipoUtente" },
  { text: "Documento", value: "documento" },
  { text: "Stato", value: "stato" },
  { text: "Note", value: "note" },
];

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setCurrentDosId(to.params.id);
    });
  },
  data() {
    return {
      headers,
    };
  },
  methods: {
    ...mapActions({
      setCurrentDosId: "docsAzi/setCurrentDosId",
      fetchList: "docsAzi/fetchHistoryDossier",
    }),
  },
  computed: {
    ...mapGetters({
      items: "docsAzi/historyDossier",
    }),
  },
};
</script>

<style>
</style>